// Product ID to single Variant ID mapping
var tangent_selected_product_map;

const default_addToCartText = "Add to Bag";
const default_addedToCartText = "Added to Bag!";
const default_add_all_to_cart_text = "Add all to Bag"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No Products Found";

// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};
let tangent_recommended_products;
// Add default image url here
var tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

let tangent_client_domain_currency;
var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
const tangent_add_all_to_cart = document.querySelector("#tangent-add-to-cart-link");
const tangent_add_all_to_cart_button = document.querySelector("#tangent-add-to-cart-text");
const tangent_shipping_popup = document.getElementById('vat-modal-overlay');
const closeButton = document.querySelector("#tangent-modal-close-button"); 


window.onload = function() {
  var tangent_response_id = getClientResponseId();
  if (tangent_add_all_to_cart) {
    tangent_add_all_to_cart.href = tangent_client_domain_url + "/cart/add?";
  }
  checkoutDataApiCall(tangent_response_id);
};


function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    tangent_recommended_products = response.products;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }
    hideLoading();
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
      // tangent_add_all_to_cart_button.classList.remove("tangent-hidden");
      setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
      enableButtonListener();
      loadElementsOnResponseData();           
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          
          const variant = getSelectedVariant(product, selected_variants);

          // Check product validity after rendering
          let productStatus = isProductAvailable(product, variant);
          if(productStatus){
            // Track selected product variant
            tangent_selected_product_map[product.id] = variant.id;
  
            // Generate product HTML and append it to the fragment
            const product_html = getProductHTML(product, p, variant, section, product);
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = product_html;
  
            // Append the created product HTML to the fragment
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }
        }
      }
    }
    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => variant.node.id === selectedVariantId).node || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getVariantForProduct(product, selected_variants) {
  if (selected_variants[product.id]?.length > 0) {
    const variant_id = selected_variants[product.id][0];
    return product.variants.find(variant => String(variant.id) === variant_id) || product.variants[0];
  }
  return product.variants[0];
}

function getProductHTML(product, index, variant, section) {
  // Setting default / first variant data
  const product_price = variant.price;
  const variantId = extractIdFromGid(variant.id);
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
  const reviewContent = product.reviews_average ? getReviewsHTML(product.reviews_average.value, product.reviews_count.value): '';
  let variantTitle = "";

  if(variant.title!="Default Title"){
    variantTitle = variant.title;
  }
  let cart_button_class="" ;
  updateAllToCartLink(variantId);
  // Product View HTML using template literals
  const product_html = `
    <div class="tangent-product" data-product-index="${index}">
      <div>
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          <p class="tangent-product-title tangent_product_title_text card__heading h5">
            ${product.title} <span>(${variantTitle})</span>
          </p>
        </a>
        ${reviewContent}
        <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${product_price} <span class="tangent-price-per-volume">${tangent_client_domain_currency}${costPer100ml(product_price, variantTitle)}/100ml</span></p>
        <p class="tangent-VAT-text">Including VAT, excluding <a class='tangent-shipping-popup'>shipping</a></p>
        
        <div id="${section}_variant_${index}"></div>
      </div>
      <div>
        ${renderProductOptions(product,variant)}
        <button id="${variantId}" class="tangent-product-add-button-wrapper tangent-btn-add tangent_add_to_cart_button ${cart_button_class}">
          ${default_addToCartText}
        </button>
      </div>
    </div>
  `;
  
  return product_html;
}

function renderProductOptions(product, selectedVariant) {
  if (!product?.options?.length) return "";

  // Map selected variant options
  const selectedMap = {};
  selectedVariant?.selectedOptions?.forEach(opt => {
    selectedMap[opt.name] = opt.value;
  });

  // Build a quick lookup for availability
  const variantAvailability = {};
  (product.variants?.edges || []).forEach(({ node }) => {
    const key = node.selectedOptions.map(opt => `${opt.name}:${opt.value}`).join("|");
    variantAvailability[key] = node.availableForSale;
  });

  // Build HTML
  const html = product.options.map(option => {
    const optionsHTML = option.values.map(value => {
      const key = `${option.name}:${value}`;
      const isAvailable = Object.keys(variantAvailability).some(
        k => k.includes(key) && variantAvailability[k]
      );
      const isSelected = selectedMap[option.name] === value;

      return `
        <label 
          class="tangent-option-item ${isSelected ? "selected" : ""} ${!isAvailable ? "disabled" : ""}"
        >
          <input
            type="radio"
            name="${option.name}"
            value="${value}"
            ${isSelected ? "checked" : ""}
            ${!isAvailable ? "disabled" : ""}
          />
          <span class="tangent-option-value-text">${value}</span>
        </label>
      `;
    }).join("");

    return `
      <div class="tangent-option-group">
        <div class="tangent-option-values">${optionsHTML}</div>
      </div>
    `;
  }).join("");

  return `<div class="tangent-product-options">${html}</div>`;
}

function costPerLitre(price, volume) {
  let volumeNumber; 
  if(volume!="set"){
    // Extract numeric value if 'ml' is included
    volumeNumber = parseFloat(volume);

    if (isNaN(volumeNumber) || volumeNumber <= 0) {
      throw new Error("Invalid volume value");
    }
  }
  else{
    return `${price}/${volume}`;
  }
  const pricePerLitre = (price / volumeNumber) * 1000;
  return Math.round(pricePerLitre * 100) / 100;
}
function costPer100ml(price, volume) {
  let volumeNumber; 
  if(volume.toUpperCase()!="SET"){
    // Extract numeric value if 'ml' is included
    const volumeNumber = parseFloat(volume);

    if (isNaN(volumeNumber) || volumeNumber <= 0) {
      throw new Error("Invalid volume value");
    }
  }
  else{
    return `${price}/${volume}`;
  }
  const pricePer100ml = (price / volumeNumber) * 100;
  return Math.round(pricePer100ml * 100) / 100;
}


function extractIdFromGid(gid) {
  const match = gid.match(/\/(\d+)$/);
  return match ? match[1] : null;
}

function getReviewsHTML(average, count){
  return `
    <div class="tangent-review-content-section">${getStarRatingHTML(average)} ${getReviewCountHTML(count)}</div>
  `;
}

function getReviewCountHTML(count){
  return `<p class="tangent-review-count-text">(${count} reviews)</p>`;
}

function getStarRatingHTML(average, opts = {}) {
  const size = opts.size ?? 13;
  const color = opts.color ?? 'rgba(2,195,194,1)';
  const emptyColor = opts.emptyColor ?? '#FFFFFF';
  const avg = Math.max(0, Math.min(5, Number(average) || 0)); // clamp 0..5
  const uid = 'stars_' + Date.now().toString(36) + Math.floor(Math.random()*10000).toString(36);

  // container style (matches your sample)
  const containerStyle = 'display:flex;flex-direction:row;margin-left:0px;margin-right:10px;align-items:center;height:28px;';

  // star path from your example
  const starPath = 'M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z';

  let starsHtml = `<div style="${containerStyle}">`;

  for (let i = 1; i <= 5; i++) {
    // fullness for this star: 1.0 full, 0 empty, fractional between
    const fullness = Math.max(0, Math.min(1, avg - (i - 1)));
    const percent = Math.round(fullness * 100); // integer percent for stop offset
    const gradId = `${uid}_grad_${i}`;

    // choose class similar to your example: full / half / empty (half used if 0<percent<100)
    let cls = 'yotpo-sr-star-empty';
    if (percent === 100) cls = 'yotpo-sr-star-full';
    else if (percent > 0) cls = 'yotpo-sr-star-half';

    // star wrapper style (matches sample margin)
    const starWrapperStyle = i < 5 ? 'display:flex;flex-direction:row;margin-right:3.5px;' : 'display:flex;flex-direction:row;';

    // Build SVG: linearGradient with stop at `percent%` to create partially filled star
    // First stop at `percent%` with the fill color, second stop at same offset with empty color.
    starsHtml += `
      <div class="star-container ${cls}" style="${starWrapperStyle}">
        <svg viewBox="0 0 18 18" tabindex="0" xmlns="http://www.w3.org/2000/svg" role="img" width="${size}" height="${size}" aria-label="Star ${i} out of 5">
          <defs>
            <linearGradient aria-hidden="true" id="${gradId}">
              <stop offset="${percent}%" stop-color="${color}"></stop>
              <stop stop-opacity="1" offset="${percent}%" stop-color="${emptyColor}"></stop>
            </linearGradient>
          </defs>
          <path aria-hidden="true" style="pointer-events: none;" d="${starPath}" stroke="${color}" fill="url('#${gradId}')"></path>
        </svg>
      </div>`;
  }

  starsHtml += `</div>`;
  return starsHtml;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

function updateAllToCartLink(id){
  tangent_add_all_to_cart.href=tangent_add_all_to_cart.href+"&id[]=" + id;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections,product_id,vid){
    if(product_sections!=undefined){
        for (const section in product_sections) {

            // Create and add all sections cart values to a map
            if (product_sections[section].includes(String(product_id))) {
                if(sections_add_to_cart_map[section]){
                    if(!sections_add_to_cart_map[section].list.includes(vid)){
                      sections_add_to_cart_map[section].count++;
                      sections_add_to_cart_map[section].cart_link =  sections_add_to_cart_map[section].cart_link+ "&id[]=" + vid;
                      sections_add_to_cart_map[section].list.push(vid);
                      
                      // Enable / disable add all to cart based on products count
                      if(sections_add_to_cart_map[section].count>1){
                          document.getElementById(section+"_add_all_to_cart").style.display="block";
                      }
                    }
                }
                else{
                    sections_add_to_cart_map[section] = {
                        count:1,
                        cart_link: tangent_client_domain_url + "/cart/add?id[]="+vid,
                        list:[vid]
                    }
                }
            }                                
        }
    }
}

const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

// Add to cart button for sections

function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart", section_name+"_add_all_to_cart", "btn");
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(add_all_to_cart_button); },
        false
    );
    return add_all_to_cart_button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else if(section_name == "section_additional_product"){
              var section_additional = document.querySelector("#section_additional_content_container_parent");
              section_additional.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    hideLoading();
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

function enableButtonListener() {
    // Listner for section add all to carts
    const all_btns = document.querySelectorAll('.tangent-product-add-button-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCartButtonClick(this); },
            false
        );
    }

    const openButtons = document.querySelectorAll('.tangent-shipping-popup');

    openButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        tangent_shipping_popup.style.display="block";
        tangent_shipping_modal_content.innerHTML = shippingPopupHTML;
      });
    });

    closeButton.addEventListener('click', function(e) {
      tangent_shipping_popup.style.display="none";
    });
}

function loadElementsOnResponseData() {
  const all_elements = document.querySelectorAll('.load-on-data');
  all_elements.forEach(el => (el.style.display = "block"));

  // Attach listeners separately
  initVariantOptionListeners();
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => ({
      id: id,
      quantity: 1
    }))
  };
}

function addToCartButtonClick(element){
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}


// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}

function initVariantOptionListeners() {
  document.addEventListener("change", (e) => {
    if (!e.target.matches('.tangent-option-item input[type="radio"]')) return;
    const input = e.target;
    const name = input.name;
    const value = input.value;

    // Find product card container
    const productContainer = input.closest('.tangent-product');
    if (!productContainer) return;

    // Remove highlight for all radios in the same group
    const groupItems = productContainer.querySelectorAll(
      `.tangent-option-item input[name="${name}"]`
    );
    groupItems.forEach(radio =>
      radio.closest(".tangent-option-item")?.classList.remove("selected")
    );

    // Add highlight to selected option
    input.closest(".tangent-option-item")?.classList.add("selected");

    // ✅ Trigger variant update
    updateProductVariant(productContainer, name, value);
  });
}

function updateProductVariant(productContainer, changedName, changedValue) {
  const productIndex = productContainer.dataset.productIndex;
  const product = tangent_recommended_products?.[productIndex];
  if (!product) return;

  const variants = product.variants?.edges?.map(e => e.node) || [];
  if (!variants.length) return;

  const selectedOptions = getSelectedOptions(productContainer);

  const matchedVariant = findMatchingVariant(variants, selectedOptions);
  if (!matchedVariant) {
    console.warn("No matching variant found for selected options");
    return;
  }

  updateProductImage(productContainer, matchedVariant);
  updateProductTitle(productContainer, matchedVariant);
  updateProductPrice(productContainer, matchedVariant);
  updateAddToCartButton(productContainer, product, matchedVariant);
}

function getSelectedOptions(productContainer) {
  return Array.from(
    productContainer.querySelectorAll('.tangent-option-item input[type="radio"]:checked')
  ).map(input => ({
    name: input.name,
    value: input.value
  }));
}

function findMatchingVariant(variants, selectedOptions) {
  return variants.find(variant =>
    variant.selectedOptions.every(opt =>
      selectedOptions.some(sel => sel.name === opt.name && sel.value === opt.value)
    )
  );
}

function updateProductImage(productContainer, variant) {
  const imgEl = productContainer.querySelector('.tangent_product_image');
  if (imgEl && variant.image?.url) {
    imgEl.src = variant.image.url;
  }
}

function updateProductTitle(productContainer, variant) {
  const titleSpan = productContainer.querySelector('.tangent-product-title span');
  if (titleSpan) {
    titleSpan.textContent = `(${variant.title})`;
  }
}

function updateProductPrice(productContainer, variant) {
  const priceEl = productContainer.querySelector('.tangent_product_price_text');
  if (!priceEl || !variant.contextualPricing?.price?.amount) return;

  const product_price = parseFloat(variant.contextualPricing.price.amount).toFixed(2);
  const variantTitle = variant.title;

  priceEl.innerHTML = `
    ${tangent_client_domain_currency}${product_price}
    <span class="tangent-price-per-litre">
      ${tangent_client_domain_currency}${costPerLitre(product_price, variantTitle)}/l
    </span>
  `;
}

function updateAddToCartButton(productContainer, product, variant) {
  const addBtn = productContainer.querySelector('.tangent_add_to_cart_button');
  if (!addBtn) return;

  const variantId = extractIdFromGid(variant.id);
  addBtn.id = variantId;
  addBtn.disabled = !variant.availableForSale;
  addBtn.textContent = variant.availableForSale ? default_addToCartText : out_of_stock_text;
}
